import { Avatar, Typography } from '@mui/material'

import { ETranslationNs, IImpactByIdRawRespDto } from 'src/types'
import { TextCell } from '../text-cell.component'

import { useStyles } from '../styles'
import { useStyles as useStyles1 } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  impact: IImpactByIdRawRespDto | null
  quantity: string | null
  quantity_type: string | null
}

export const ImpactRecord = ({ impact, quantity, quantity_type }: IProps) => {
  const classes = useStyles()
  const classes1 = useStyles1()

  return (
    <div>
      <div className={classes1.imageIconWrapper}>
        <div className={classes.iconWrapper}>
          {impact ? (
            <>
              <Avatar
                src={impact.image_small || impact.image}
                alt={impact.name}
                variant="circular"
              />
              <TextCell primaryAccent primary={impact.name} secondary={impact.name} />
            </>
          ) : (
            '-'
          )}
        </div>
      </div>
      <div className={`${classes1.imageIconWrapper} ${classes1.impactQuantity}`}>
        <Typography variant="body2">
          <HelperWrapper t="quantity-label-text" ns={ETranslationNs.Scans} />
        </Typography>{' '}
        {quantity || '-'}
      </div>
      <div className={classes1.imageIconWrapper}>
        <Typography variant="body2">
          <HelperWrapper t="scan-history-quantity-type-label" ns={ETranslationNs.Scans} />:
        </Typography>
        {quantity_type || '-'}
      </div>
    </div>
  )
}
